import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { useTable } from "@website/ui/datepicker/components/table/table.hook";
import styles from "@website/ui/datepicker/components/table/table.module.scss";
import { TablePropertiesType } from "@website/ui/datepicker/components/table/table.types";
import { MONTH_NAMES, WEEK_ABBR } from "@website/ui/datepicker/constanst";
import { Tooltip } from "@website/ui/tooltip/tooltip";
import { numberConvert } from "@website/utils/number-convert";
import { FC } from "react";
export const Table: FC<TablePropertiesType> = properties => {
  const $ = _c(24);
  const {
    calendarLocale,
    year,
    month,
    type,
    view,
    isLabelTop,
    hasExtraData
  } = properties;
  const {
    days
  } = useTable(properties);
  const isFlat = type === "flat";
  const t0 = `${styles.container} ${isFlat ? styles["container-flat"] : ""} ${styles["rtl" || "ltr"]}`;
  const t1 = `${isFlat && view !== "mobile" ? styles["week-names-container-desktop-flat"] : !isFlat && view !== "mobile" ? `${styles["week-names-container-desktop"]} ${styles["week-names-container-desktop__default"]}` : styles["week-names-container-desktop"]} `;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [1, 2, 3, 4, 5, 6, 7];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== calendarLocale || $[2] !== isFlat) {
    t3 = t2.map(week => <div className={styles["week-name"]} key={week}><div className={isFlat ? styles["aspect-ratio-content"] : ""}>{WEEK_ABBR[calendarLocale][week - 1]}</div></div>);
    $[1] = calendarLocale;
    $[2] = isFlat;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <div className={t1}>{t3}</div>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `${styles["month-name"]} ${view === "mobile" ? "" : styles["month-name__default"]} ${isLabelTop ? "absolute inset-x-0 top-0 z-[-1] !mt-4" : ""}`;
  const t6 = (MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[month - 1];
  let t7;
  if ($[7] !== year) {
    t7 = numberConvert(year, {
      numberOnly: true,
      locale: "fa"
    });
    $[7] = year;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t6 || $[11] !== t7) {
    t8 = <div className={t5}>{t6}{" "}{t7}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [0, 1, 2, 3, 4, 5];
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== days || $[15] !== hasExtraData || $[16] !== isFlat || $[17] !== view) {
    t10 = t9.map(row => {
      if (days[row * 7]?.value !== -1 || days[row * 7 + 6]?.value !== -1) {
        return <div className={styles.row} key={row}>{[0, 1, 2, 3, 4, 5, 6].map((cell, cellIndex) => {
            const index = row * 7 + cellIndex;
            const cellText = days[index]?.value === -1 ? "" : days[index]?.value;
            const cellContent = days[index]?.content;
            const state = days[index]?.state;
            const isToday = days[index]?.isToday;
            const nonInstantAvailability = days[index]?.nonInstantAvailability;
            const availability = days[index]?.availability;
            const tooltip = days[index]?.tooltip;
            return <div className={`${styles.cell} ${hasExtraData ? "!aspect-auto !h-[56px] md:min-w-[44px]" : ""} ${isFlat ? styles.cell__flat : view === "mobile" ? styles.cell__mobile : styles.cell__default} ${isToday ? styles.today : ""} ${state ? styles[state] : ""}`} key={cell} onClick={days[index]?.onClick}><div className={`${styles["cell-inside"]} ${isFlat ? styles["cell-inside__flat"] : view === "mobile" ? styles["cell-inside__mobile"] : styles["cell-inside__default"]}`}><Tooltip className="!h-max !w-full" placement="top" title={tooltip} titleClassName={`!left-0 ${!tooltip && "hidden"}`}>{nonInstantAvailability === 0 && availability > 0 && <MaterialIcon className="text-warning -mb-2 flex !w-full self-end" name="bolt" />}<div className="w-full text-center">{numberConvert(cellText, {
                      numberOnly: true,
                      locale: "fa"
                    })}</div>{Boolean(cellContent) && <span className={styles["cell-inside-data"]}>{cellContent}</span>}</Tooltip></div></div>;
          })}</div>;
      }
      return null;
    });
    $[14] = days;
    $[15] = hasExtraData;
    $[16] = isFlat;
    $[17] = view;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t0 || $[20] !== t10 || $[21] !== t4 || $[22] !== t8) {
    t11 = <div className={t0}>{t4}{t8}{t10}</div>;
    $[19] = t0;
    $[20] = t10;
    $[21] = t4;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};